module.exports = __webpack_public_path__ + "img/MUSA-26.0df17338.jpg";